module.exports = __webpack_public_path__ + "media/images/original/preview-e6e41a84cc1d1dd0fbf4d36d91cf0ac4.png";